import Vue from 'vue';
import {InertiaProgress} from '@inertiajs/progress'
import {createInertiaApp, Head, Link} from '@inertiajs/vue2'
import Layout from "@/Shared/Layout";
import Buefy from 'buefy'
import store from './store';
import wysiwyg from "vue-wysiwyg";
window._ = require('lodash')
require('./filters');
Vue.use(Buefy);
Vue.use(wysiwyg, {});
require("vue-wysiwyg/dist/vueWysiwyg.css");
InertiaProgress.init()

let ignoredLayoutPages = [
  'Auth/Login',
  'LeadForm',
];
store.dispatch('layoutMobileToggle')

window.onresize = () => {
  store.dispatch('layoutMobileToggle')
}

createInertiaApp({
  resolve: async name => {
    // let page = (await import(`./Pages/${name}`)).default;
    let page = require(`./Pages/${name}`).default;

    if(ignoredLayoutPages.includes(name) || page.layout) {
      return page;
    }

    page.layout = Layout;

    return page;
  },
  title: title => title ? `${title} - Normandy Labs` : 'Normandy Labs',
  setup({el, App, props, plugin}) {
    Vue.use(plugin)
    Vue.component('Link', Link);
    Vue.component('Head', Head);
    new Vue({
      store,
      render: h => h(App, props),
    }).$mount(el)
  },
})
